module.exports = __webpack_public_path__ + "img/available-bike.b89c5958.svg";